// Constantes.js
export default class Constantes {
  //variaveis universais

  static logado = false;
  static url_base = "https://api.fitpace.com.br/api/";
  //urls
  static end_point_back_end_mercado_pago = 'mercadopago/processa_pagamento.php';
  static end_point_back_end_mercado_pago_boleto = 'mercadopago/processa_pagamento_boleto.php';
  static end_point_back_end_mercado_pago_atualiza = 'mercadopago/atualiza_pagamento.php';
  static end_point_back_end_mercado_pago_TESTE = 'mercadopago/pagamento_teste.php';
  static public_key_mercado_pago_teste = "TEST-bbefe4e8-bbbd-4298-9547-4481871c9f3d";
  static public_key_mercado_pago = "APP_USR-04e95284-a34a-4018-ab1f-d242c11d3ca6";
  static url_baixar_boleto = this.url_base + "mercadopago/baixar_boleto.php?id=";
  static url_pagar_cartao = this.url_base + "mercadopago/processa_pagamento_cartao.php";
  //navegacao
  static tela_pagamento = "/pagamento";
  static tela_pre_pagamento_plano= "/pre_pagamento_plano";
  static tela_do_atleta = "/tela_do_atleta";
  static tela_pre_pagamento = "/prepagamentos";
  static tela_montar_campeonatos = "/montarcampeonatos";
  static tela_montar_um_campeonato = "/montarumcampeonato";
  static tela_inscritos = "/inscritos";
  static tela_exibe_inscritos = "/inscrito";

  static tela_relatorios = "/relatorios";
  static tela_sucesso_pagamento = "/sucesso_pagamento";
  static tela_monta_intervalo = "/monta_intervalo";
  static tela_cadastrar_treino_atleta = "/cadastrar_treino_atleta";
  static tela_exibe_plano_corrida = "/exibe_plano_corrida";
  static tela_anamnese = "/anamnese";
  static tela_exibe_lista_treinos = "/lista_treinos";
  static tela_teste_corrida = "/teste_corrida";
  static tela_propaganda_cadastrar_treino = "/como_prescrever";
  static tela_pre_pagamento_id = "/prepagamentos/:id";
  static tela_minhas_incricoes = "/minhasinscricoes";
  static tela_assessorias = "/assessorias";
  static tela_calcula_zona = "/calcula_zona";
  static tela_calcula_pace = "/calcula_pace";
  static tela_meu_cadastro = "/meu_cadastro";
  static tela_sobre = "/sobre";
  static tela_afiliados = "/afiliados";
  static tela_planos = "/planos";
  
  
  static tela_menu_config = "/config";
  static tela_menu = "/menu";
  static tela_pre_inscricao = "/preinscricao";
  static tela_exibir_camisas = "/exibircamisas";
  static tela_editar_camisas = "/tamanhocamisa";
  static tela_login = "/login";
  static tela_login2 = "/login2";
  static tela_cupons = "/cupons";
  static tela_editar_cupons = "/editar_cupons";

  //permissoes

  static pode_montar_campeonatos = "pode_montar_campeonatos";
  static pode_ver_relatorios = "pode_ver_relatorio";
  static pode_editar_camisas = "pode_editar_camisas";
  static pode_editar_cupons = "pode_editar_cupons";
  static pode_editar_inscricao = "pode_editar_inscricao";
  static pode_ver_configuracoes = "pode_ver_configuracoes";
  static pode_ver_inscritos = "pode_ver_inscritos";
  static pode_ver_meu_cadastro = "pode_ver_meu_cadastro";

  //querycodes

  static query_code_consultar_campeonato = "consultar_campeonato";
  static query_code_consultar_planos_contratacao = "consultar_planos_contratacao";
  static query_code_consultar_resumo_pagamento_inscricao = "consultar_resumo_pagamento_inscricao";
  static query_code_consultar_resumo_pagamento_plano = "consultar_resumo_pagamento_plano";
  static query_code_consultar_minhas_inscricao = "consultar_minhas_inscricoes";
  static query_code_consultar_eventos_incritos = "consultar_eventos_incritos";
  static query_code_cadastrar_novo_usuarios = "cadastrar_usuario";
  static query_code_pagamentos_disponives = "pagamentos_disponiveis";
  static query_code_pagamentos_disponives_andlline = "pagamentos_disponiveis_andlline";
  static query_code_consulta_livre = "consulta_generica_livre";
  static query_code_consulta_livre_sem_deletado = "consulta_generica_livre_sem_coluna_deletado";
  static query_code_consulta_cadastro_usuario = "consulta_cadastro_usuario";
  static query_code_consulta_assessorias = "consulta_assessorias";
  static query_code_consulta_usuarios_metas_zonas = "consulta_usuarios_metas_zonas";
  static query_code_consulta_usuarios_metas_zonas_usuario = "consulta_usuarios_metas_zonas_usuario";
  static query_code_consulta_usuarios_metas_zonas_update = "consulta_usuarios_metas_zonas_update";

  //apis
  static api_inserir_padrao = "inserir.php";
  static api_cadastrar_usuario = "cadastrar_usuario.php";
  static api_insere_pre_pagamento_plano = "insere_pre_pagamento_plano.php";
  static api_inserir_testes_corrida = "inserir_testes_corrida.php";
  static api_inserir_sem_query_code = "inserir_sem_query_code.php";
  static api_inscricao_campeonato = "inscricao_campeonato.php";
  static api_inscricao_planilha = "inscricao_planilha.php";
  static api_cria_treino_corrida = "cria_treino_corrida.php";
  static api_editar_padrao = "editar.php";
  static api_consultar_padrao = "consultas.php";
  static api_gerar_comprovante = this.url_base + "gerar_pdf.php?cod=";
  static api_gerar_planilha = this.url_base + "gera_planilha_pdf.php";
  static api_gerar_certificado = this.url_base + "gerar_certificado.php?cod=";
  static api_enviar_email_sms = "sms/enviar_ambos.php";
  static api_consultar_sem_retorno = "consultas_sem_retorno.php";
  static api_pagar_cartao_pro = "mercadopago/processa_pagamento_cartao_checkout_pro.php";
  static api_insere_edita_metas_zonas = "insere_edita_metas_zonas.php";



  //tabelas

  static nome_tabela_cadastrar_usuarios_incricao = "usuarios";

  //msg de formulario
  static msg_inserido_sucesso = "Os dados foram inseridos com sucesso! ";
  static msg_alterado_sucesso = "Os dados foram alterados com sucesso! ";
  static msg_apagados_sucesso = "Os dados foram apagados com sucesso! ";
  static msg_confirma_alterar_dados = "Certeza que deseja alterar os dados?";
  static msg_confirma_apagar_dados = "Certeza que deseja APAGAR os dados?<br>NÃO PODERÁ SER DESFEITO! ";
  static msg_campos_obrigatorios = "Campos obrigatorórios não preenchidos: ";
  static msg_formato_invalido = "Campos preenchidos com dados inválidos: ";
  static msg_erro_conexao_generica = "Não foi possível conectar ao banco de dados. Verifique sua conexão com a internet e tente novamente! cod.06";
  static msg_boleto_gerado_sucesso = "Boleto gerado com sucesso!";
  static msg_inscricao_duplicada = "Não foi possível realizar a inscrição. Já existe uma inscrição para essa categoria para esse CPF. Veja suas incriçoes em <a href='/minhasinscricoes'>'minhas inscrições'</a>";

  //login
  static msg_senha_invalida = "Usuário e/ou senha  inválidos! ";
  static msg_login_sucesso = "Login efetuado com sucesso! ";
  static msg_senhas_nao_coincidem = "As senhas não coincidem.";
  static msg_emails_nao_coincidem = "Os emails  não coincidem.";

  //botoes
  static botao_positivo = "Sim";
  static botao_negativo = "Não";
  static titulo_botao_enviar_inscricao = "Inscrever";
  static titulo_botao_avancar = "Avançar";
  static titulo_ir_para_inscricao = "Ir para inscrição";
  static titulo_botao_voltar = "Voltar";
  static titulo_ver_boleto = "Ver boleto";
  static titulo_baixar_boleto = "Baixar boleto";
  static botao_cancelar = "Cancelar";



  //msg de erro
  static msg_erro_conexao_bd = "Não foi possível conectar ao banco de dados. Cod. 01";
  static msg_erro_alteracao_dupla = "Dado duplicado. Não foi possível modificar Cod. 02";
  static msg_erro_insercao_dupla = "Dado duplicado. Não foi possível inserir Cod. 03";


  //msg pedaco de tela
  static msg_placeholder_selecao = "Selecione uma opção";
  static msg_item_nao_encontrado = "Item não encontrado";
  static msg_opcao_invalida = "Opção Inválida";


  //static imagems

  static logo_wodoxi_timbre = "https://www.wodoxi.com.br:447/img/WODOXI_timbre.png";
  static logo_mercado_pago = "https://www.wodoxi.com.br:447/img/mercadopago.png";
  //config
  static versao = "v.1.0.61";
}
